module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/Ultra-wide Angle Module.cdeb55cf.png";